// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__CQ0je","barLabelOutside":"task-list_barLabelOutside__IWx-R"};